import axios from './axios';

export const paymentAPI = {
  initiate: async (orderId) => {
    const response = await axios.post('/payment/initiate', { order_id: orderId });
    return response.data;
  },

  verify: async (transactionId) => {
    const response = await axios.post('/payment/verify', { transaction_id: transactionId });
    return response.data;
  },
};